import React from 'react';
import {getSizedImageUrl} from '@shopify/theme-images';

const PromoBanner = () => {
  const bannerImage = window.theme?.cartBanner?.image;
  const bannerText = window.theme?.cartBanner?.text;
  const bannerURL = window.theme?.cartBanner?.url;
  const textColor = window.theme?.cartBanner?.textColor;
  const backgroundColor = window.theme?.cartBanner?.backgroundColor;

  let customStyle = `
    ${textColor ? `--banner-text-color: ${textColor};` : ''}
    ${backgroundColor ? `--banner-background-color: ${backgroundColor};` : ''}
  `;

  return (
    <div className="side-cart__banner side-cart__section" style={customStyle}>
      {bannerURL ? (
        <a className="side-cart__banner-content" href={bannerURL}>
          {bannerImage && (
            <div className="side-cart__banner-image component-image__wrapper aspect-ratio aspect-ratio--landscape">
              <img
                src={getSizedImageUrl(bannerImage, '720x')}
                width={720}
                height={540}
                alt={bannerText}
                loading="lazy"
              />
            </div>
          )}
          {bannerText && <p className="side-cart__banner-text">{bannerText}</p>}
        </a>
      ) : (
        <div className="side-cart__banner-content">
          {bannerImage && (
            <div className="side-cart__banner-image component-image__wrapper aspect-ratio aspect-ratio--landscape">
              <img
                src={getSizedImageUrl(bannerImage, '720x')}
                width={720}
                height={540}
                alt={bannerText}
                loading="lazy"
              />
            </div>
          )}
          {bannerText && <p className="side-cart__banner-text">{bannerText}</p>}
        </div>
      )}
    </div>
  );
};

export default PromoBanner;
